import { API_BASE_URL } from './apiConfig';
import { handleUnauthorized } from './authApi';

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('casapizza_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const fetchJson = async (url) => {
  const res = await fetch(url, { headers: getAuthHeaders() });
  if (!res.ok) {
    if (res.status === 401) handleUnauthorized();
    throw new Error(`HTTP ${res.status}`);
  }
  return res.json();
};

const buildUrl = (path, params = {}) => {
  const url = new URL(`${API_BASE_URL}${path}`, window.location.origin);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined) url.searchParams.set(k, v);
  });
  return url.toString();
};

export const fetchSummary = (period, branchId) =>
  fetchJson(buildUrl('/admin/metrics/summary', { period, branch_id: branchId }));

export const fetchOrdersByBranch = (period) =>
  fetchJson(buildUrl('/admin/metrics/by-branch', { period }));

export const fetchOrdersByChannel = (period, branchId) =>
  fetchJson(buildUrl('/admin/metrics/by-channel', { period, branch_id: branchId }));

export const fetchHourlyHeatmap = (period, branchId) =>
  fetchJson(buildUrl('/admin/metrics/hourly-heatmap', { period, branch_id: branchId }));

export const fetchSLA = (period, branchId) =>
  fetchJson(buildUrl('/admin/metrics/sla', { period, branch_id: branchId }));

export const fetchBotConversion = (period) =>
  fetchJson(buildUrl('/admin/metrics/bot-conversion', { period }));

export const fetchTopProducts = (period, branchId, limit = 10) =>
  fetchJson(buildUrl('/admin/metrics/top-products', { period, branch_id: branchId, limit }));

export const fetchLive = () =>
  fetchJson(buildUrl('/admin/live'));

const sendJson = async (url, method, body) => {
  const res = await fetch(url, {
    method,
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    if (res.status === 401) handleUnauthorized();
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
};

export const fetchUsers = () =>
  fetchJson(buildUrl('/admin/users'));

export const createUser = (payload) =>
  sendJson(buildUrl('/admin/users'), 'POST', payload);

export const updateUser = (id, payload) =>
  sendJson(buildUrl(`/admin/users/${id}`), 'PUT', payload);

export const updateRestaurantConfig = (payload) =>
  sendJson(buildUrl('/admin/restaurant/config'), 'PUT', payload);
